// Old, pre-defined spotlight screens. Please don't add to this enum!
export enum SpotlightScreen {
  TEMPLATES = 'spotlight-templates',
  TOOLBAR = 'spotlight-toolbar',
  MORE_TOOLS = 'spotlight-more-tools',
  STICKY_NOTE_CREATOR = 'spotlight-sticky-creator',
  STICKY_NOTE_VIEWER = 'spotlight-sticky-viewer',
  TOOLBAR_FULL = 'spotlight-toolbar-full',
  EXPORTS = 'spotlight-exports',
}

type SpotlightType = string & { __screenType: symbol };

export type SpotlightScreenType = SpotlightType | SpotlightScreen;

// type creator
export const spotlightScreenType = (type: string) => {
  return type as SpotlightScreenType;
};
